<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header justify-content-between border-0">
        <h5 class="card-title font-bold">مشاوره ها</h5>
        <b-button @click="readGuidesAll" v-if="btnStatus" variant="success"
          >خوانده شده</b-button
        >
      </div>
      <div class="card-body">
        <div>
          <b-table
            responsive
            hover
            bordered
            :items="items.data"
            :fields="fields"
          >
            <template #head(select)="row">
              <b-form-checkbox
                :disabled="items == null"
                class="text-center text-dark"
                :id="'checkbox-all' + row.label"
                name="checkboxall"
                @change="guideSelectAll"
                v-model="allSelected"
              >
              </b-form-checkbox>
            </template>
            <template #cell(select)="row">
              <b-form-checkbox
                class="text-center text-dark table-checkbox"
                :notselected="!selectedGuides[row.index]"
                :selected="selectedGuides[row.index]"
                :id="'checkbox' + row.item.id"
                :name="'checkbox' + row.item.id"
                @change="guideSelect(row.index, row.item)"
              >
              </b-form-checkbox>
            </template>
            <template v-slot:cell(is_read)="data">
              <span
                v-if="data.item.is_read == 1"
                class="badge badge-success status"
                >خوانده شده</span
              >
              <span
                v-else-if="data.item.is_read == 0"
                class="badge badge-danger status"
                >خوانده نشده</span
              >
            </template>
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | persianDate }}
            </template>
            <template v-slot:cell(show)="data">
              <a
                @click="showItem(data.item.id)"
                :disabled="disabled ? true : false"
                class="action-btns1  pt-1 px-2"
              >
                <i class="fe fe-eye   text-primary"></i>
              </a>
            </template>
            <template v-slot:cell(delete)="data">
              <span :id="'delete-btn-' + data.item.id">
                <a
                  class="action-btns1  pt-1 px-2 "
                  @click="deleteItem(data.item.id)"
                >
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </span>
            </template>
          </b-table>
          <Loading v-if="$root.isEmptyObject(items)" />
          <pagination
            v-if="items.data != ''"
            :limit="2"
            :disabled="disabled"
            :data="items"
            @pagination-change-page="changePage"
          >
          </pagination>
          <div v-else-if="items.data == ''" class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
        <b-modal id="modal-show-guide" hide-footer centered title="مشاهده مشاوره">
          <div class="d-flex py-1">
            <h6 class="font-bold">شماره همراه :</h6>
            <h6 class="pr-1">{{ edit.mobile }}</h6>
          </div>
          <div class="d-flex py-1">
            <h6 class="font-bold">متن :</h6>
            <h6 class="pr-1">
              {{ edit.description }}
            </h6>
          </div>
          <div class="d-flex py-1">
            <h6 class="font-bold">وضعیت :</h6>
            <h6 class="pr-1">
              <span v-if="edit.is_read == 1" class="badge badge-success status"
                >خوانده شده</span
              >
              <span
                v-else-if="edit.is_read == 0"
                class="badge badge-danger status"
                >خوانده نشده</span
              >
            </h6>
          </div>
        </b-modal>
      </div>
    </div>
  </main>
</template>
<script>
import GuidesImpl from "@@/core/pages/guide/Guides/GuidesImpl.js";
export default {
  extends: GuidesImpl,
};
</script>
